import './Contact.scss'
import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import React from 'react'
import { EagerDatoImage } from '#src/components/image/EagerDatoImage.js'
import { LocalizedLink } from '#src/components/LocalizedLink.js'
import { StructuredData } from '#src/components/StructuredData.js'
import type { ContactPageData } from '#src/pages/contact/contactPageData.js'

interface Props {
  data: ContactPageData
}

export default function ContactPage({ data }: Props): ReactNode {
  return (
    <section className="contact">
      <div className="contacts__content">
        {data.image && (
          <div className="contacts__image-container">
            <EagerDatoImage
              className="contacts__image"
              responsiveImage={data.image.responsiveImage}
              sizes={['(max-width: 992px) 100vw', '50vw']}
            />
          </div>
        )}
        <div className="contacts__container">
          <div className="contacts__inner">
            <div className="contact__socials">
              {data.socialMediaLinks?.map(link => (
                <a className="contact__social-link" key={link.url} href={link.url} target="_blank">
                  {link.label}
                </a>
              ))}
            </div>
            <div className="contacts__info">
              {data.contactBlocks?.map(contact => (
                <div className="contacts__item" key={contact.label || contact.text}>
                  {contact.label && <p className="contacts__subtitle">{contact.label}</p>}
                  <a
                    className={clsx({
                      contacts__contact: true,
                      contacts__italic: contact.url?.startsWith('tel:'),
                    })}
                    href={contact.url}
                    target="_blank"
                  >
                    {contact.text}
                  </a>
                </div>
              ))}
            </div>
            {data.internalLink && (
              <LocalizedLink href={data.internalLink.url} className="contacts__navlink">
                {data.internalLink.text}
              </LocalizedLink>
            )}
          </div>
          {/* <h1 className="contacts__heading">Contact</h1>*/}
        </div>
      </div>
      {data.structuredData && <StructuredData data={data.structuredData} />}
    </section>
  )
}
